// extracted by mini-css-extract-plugin
export default {"removeModalContainer":"RemoveVirtualNumberModal_removeModalContainer__KxLv3"};